import {Component, Inject} from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from "@angular/material/dialog";
import {BaseModalComponent} from "app/shared/base-modal/base-modal.component";


@Component({
  selector: 'app-edit-menu-backup',
  templateUrl: './edit-menu-backup.component.html',
  styleUrls: ['./edit-menu-backup.component.scss']
})
export class EditMenuBackupComponent extends BaseModalComponent {
  form: FormGroup;

  constructor(
    private dialog: MatDialog,
    public dialogRef: MatDialogRef<EditMenuBackupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: EditMenuBackupModalDataType
  ) {
    super(dialogRef);
    this.form = new FormGroup({});
    this.form.addControl('menuBackupName', new FormControl(this.data.menuSectionName + ' backup ' + new Date().toISOString()))

  }

  submit() {
    this.dialogRef.close(this.form.get("menuBackupName").value);
  }
}

export interface EditMenuBackupModalDataType {
  menuSectionName: string;
}
